<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="snMaterialSnRules"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="标签编号">
            <el-input v-model.trim="filter.materialSnRuleNo" placeholder="请输入标签编号" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="规则编号">
            <el-input v-model.trim="filter.snRuleNo" placeholder="请输入规则编号" clearable/>
          </el-form-item>
          <el-form-item label="规则样式">
            <el-input v-model.trim="filter.snRuleExpression" placeholder="请输入规则样式" clearable/>
          </el-form-item>
          <el-form-item label="状态" label-width="64px">
            <el-select v-model="filter.status" placeholder="请选择状态" clearable>
              <el-option label="待确认" :value="10"/>
              <el-option label="已确认" :value="20"/>
              <el-option label="已作废" :value="90"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.detailAuth" type="primary" @click="$refs.materialSnRuleEdit.open(scope.row, 1)">详情</el-button>
      </template>
    </viewTable>
    <material-sn-rule-edit ref="materialSnRuleEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import MaterialSnRuleEdit from "./MaterialSnRuleEdit";
  export default {
    components: { viewTable, MaterialSnRuleEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(653),
          editAuth: this.$auth(654),
          delAuth: this.$auth(656),
          detailAuth: this.$auth(655),
        },
        filter: {
          materialSnRuleNo: "",
          materialNo: "",
          materialName: "",
          snRuleNo: "",
          snRuleExpression: "",
          status: "",
        },
        columnsProperty: [
          {
            key: "materialSnRuleNo",
            width: 100,
            align: "center",
          },
          {
            key: "materialNo",
            width: 170,
          },
          {
            key: "materialName",
            minWidth: 300,
          },
          {
            key: "snRuleNo",
            width: 100,
            align: "center",
          },
          {
            key: "snRuleExpression",
            minWidth: 200,
            tooltip: true,
            ellipsis: true,
          },
          {
            key: "snVersion",
            width: 90,
            align: "center",
          },
          {
            key: "statusName",
            width: 90,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 190,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.materialSnRuleEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "snMaterialSnRules", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // 已确认 已作废的物料条码不能编辑
      // otherAuth(row) {
      //   return row.status !== 10 ? true : false;
      // },
    },
  };
</script>
